import { CellContext } from '@tanstack/react-table';
import {
  ArticleListItemResultFragment,
  CollectionListItem,
  PublicationStatus,
} from 'lib-knowledge-management-common/graphql';

import {
  ArticleCell,
  ArticleHeader,
  CollectionCell,
  CollectionHeader,
  PublicationStatusCell,
  PublicationStatusHeader,
} from './cells';
import { ArticlesTableFeatures } from './features';

type ArticleTitleCellContext = CellContext<
  ArticlesTableFeatures,
  ArticleListItemResultFragment,
  string | null | undefined
>;
type GetArticleTitleColumnReturnType = {
  header: () => JSX.Element;
  cell: (info: ArticleTitleCellContext) => JSX.Element;
};

export const getArticleTitleColumn = (): GetArticleTitleColumnReturnType => ({
  header: () => <ArticleHeader />,
  cell: (info: ArticleTitleCellContext): JSX.Element => {
    const {
      updatedAt,
      updatedBy,
      createdBy,
      createdAt,
      titles,
      id,
      parentCategories,
    } = info.row.original;

    return (
      <ArticleCell
        updatedAt={updatedAt}
        updatedBy={updatedBy}
        createdBy={createdBy}
        createdAt={createdAt}
        titles={titles}
        articleId={id}
        parentCategories={parentCategories}
      />
    );
  },
});

type CollectionCellContext = CellContext<
  ArticlesTableFeatures,
  ArticleListItemResultFragment,
  Array<Omit<CollectionListItem, 'fields'>>
>;
type GetCollectionColumnReturnType = {
  header: () => JSX.Element;
  cell: (info: CollectionCellContext) => JSX.Element;
};
export const getCollectionColumn = (): GetCollectionColumnReturnType => ({
  header: () => <CollectionHeader />,
  cell: (info: CollectionCellContext) => {
    return (
      <CollectionCell
        parentCollections={info.cell.row.original.parentCollections}
        isSyncedWithElevio={info.cell.row.original.isSyncedWithElevio}
      />
    );
  },
});

type PublicationCellContext = CellContext<
  ArticlesTableFeatures,
  ArticleListItemResultFragment,
  PublicationStatus | null | undefined
>;
type GetPublicationStatusColumnReturnType = {
  header: () => JSX.Element;
  cell: (info: PublicationCellContext) => JSX.Element;
};
export function getPublicationStatusColumn(): GetPublicationStatusColumnReturnType {
  return {
    header: (): JSX.Element => <PublicationStatusHeader />,
    cell: (info: PublicationCellContext): JSX.Element => {
      const { publicationStatus } = info.row.original;
      return <PublicationStatusCell publicationStatus={publicationStatus} />;
    },
  };
}
